export const titleWidgetSample = {
  type: "title",
  title: "",
};
export const discriptionWidgetSample = {
  type: "discription",
  title: "",
};
export const cardWidgetSample = {
  type: "card",
  title: "",
  subTitle: "",
};
export const imageWidgetSample = {
  type: "image",
};
